import { useEffect, useState } from "react";



/**
 * Waits for a DOM element with the provided id to appear and returns it.
 * @param id - Element id to observe within the document.
 * @returns The matching HTMLElement once detected, otherwise undefined.
 */
export default function useElementLoaded(id: string) {

    const [_element, setElement] = useState<HTMLElement>();


    const domInserted = (e: Event) => {
        if (e.target) {
            let target = e.target as HTMLElement;
            if (target.id === id) {
                setElement(target)
            }
        }
    }

    let element = document.getElementById(id);
    if (element && !_element) {
        setElement(element)
    }
    else {
        document.addEventListener('DOMNodeInserted', domInserted);
    }

    return _element;
}


